(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hermosa-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sources = {
  "VitZzs": "Cart 1 — Zero Risk, All Reward... (Klaviyo VitZzs)",
  "VQRMQF": "Cart 2 — It looks like you left something behind... (Klaviyo VQRMQF)",
  "SNpP6W": "Cart 3 — Your cart is about to expire. (Klaviyo SNpP6W)",
  "XrWaep": "Browse 1 — Still curious about Hermosa? (Klaviyo XrWaep)",
  "V2ve7h": "Browse 2 — A few reasons people choose Hermosa (Klaviyo V2ve7h)",
  "VncKzz": "Winback 1 — Your car misses the shine… (Klaviyo VncKzz)",
  "RajVVY": "Winback 2 — We've missed you. (Klaviyo RajVVY)",
  "Yzjrsr": "Welcome 1 — Welcome to Team Hermosa! (Klaviyo Yzjrsr)",
  "UmsBNQ": "Welcome 2 — Welcome to Team Hermosa! (Klaviyo UmsBNQ)",
  "Tc3LUY": "Welcome 3 — Discover legendary shine with Hermosa Ceramic Shampoo (Klaviyo Tc3LUY)",
  "RVZFFJ": "Welcome 4 — Your 15-minute transformation routine (Klaviyo RVZFFJ)",
  "RiYD57": "Welcome 5 — Real results. Real shine. Trusted by enthusiasts. (Klaviyo RiYD57)",
  "UTQq65": "Welcome 6 — Unlock Pro-Level Protection with Ceramic Spray (Klaviyo UTQq65)",
  "XRF8uq": "Welcome 7 — Transform Your Paint With 10H Graphene Ceramic Coating (Klaviyo XRF8uq)"
};
  const applyEmailSource = () => {
    const key = new URLSearchParams(window.location.search).get("email_source");
    const source = Object.prototype.hasOwnProperty.call(sources, key) ? sources[key] : "";
    document.querySelectorAll(".hct__form [data-hos-email-source]").forEach((field) => {
      field.value = source;
      field.disabled = !source;
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyEmailSource, { once: true });
  } else {
    applyEmailSource();
  }
  document.addEventListener("shopify:section:load", applyEmailSource);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hermosa-governed-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const select = event.target.closest('select[data-hgp-gift-variant]');
  if (!select) return;
  const price = select.selectedOptions[0]?.dataset.hgpPrice;
  const product = select.closest('.hgp');
  if (!product || !price) return;
  product.querySelectorAll('.hgp__price strong, .hgp__sticky b').forEach((node) => {
    node.textContent = price;
  });
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState(window.history.state, '', url);
});
document.addEventListener('click', (event) => {
  const button = event.target.closest('.hgp__thumbs button[data-hgp-image]');
  if (!button) return;
  const gallery = button.closest('.hgp__gallery');
  const image = gallery.querySelector('.hgp__main img');
  if (!image) return;
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = button.dataset.hgpImage;
  image.alt = button.querySelector('img')?.alt || image.alt;
  gallery.querySelectorAll('[data-hgp-image]').forEach((item) =>
    item.setAttribute('aria-pressed', String(item === button)));
});

(() => {
  const initialise = () => {
    document.querySelectorAll('video[data-hermosa-ugc]').forEach(video => {
      if (video.dataset.playbackReady) return;
      video.dataset.playbackReady = 'true';
      const desktop = window.matchMedia('(min-width: 801px) and (hover: hover) and (pointer: fine)');
      const applyPlayback = () => {
        video.autoplay = desktop.matches;
        if (desktop.matches) {
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.removeAttribute('autoplay');
          video.pause();
        }
      };
      desktop.addEventListener('change', applyPlayback);
      applyPlayback();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hermosa-original-ugc"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('video[data-hermosa-ugc]').forEach(video => {
      if (video.dataset.playbackReady) return;
      video.dataset.playbackReady = 'true';
      const desktop = window.matchMedia('(min-width: 801px) and (hover: hover) and (pointer: fine)');
      const applyPlayback = () => {
        video.autoplay = desktop.matches;
        if (desktop.matches) {
          video.muted = true;
          video.play().catch(() => {});
        } else {
          video.removeAttribute('autoplay');
          video.pause();
        }
      };
      desktop.addEventListener('change', applyPlayback);
      applyPlayback();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hermosa-partners-v3"] && !Shopify.designMode) return;
  try {
    
(() => {
  const start = () => {
    if (window.Shopify?.theme?.id !== 154420740184 || location.pathname !== '/pages/hermosa-partners') return;
    const root = document.querySelector('.hpv3')?.closest('.shopify-section')?.nextElementSibling;
    if (!root) return;
    let settled = false;
    let selecting = false;
    let timer;
    let inertBefore = false;
    const formSelector = '[data-testid="klaviyo-form-SUtHdY"]';
    const finish = () => {
      const form = root.querySelector(formSelector);
      if (form && selecting) requestAnimationFrame(() => requestAnimationFrame(() => { form.inert = inertBefore; }));
      settled = true;
      clearTimeout(timer);
      observer.disconnect();
      root.removeEventListener('pointerdown', onInteraction, true);
      root.removeEventListener('keydown', onInteraction, true);
    };
    const onInteraction = event => { if (event.isTrusted && !selecting) finish(); };
    const initialise = () => {
      if (settled) return;
      const form = root.querySelector(formSelector);
      const button = form?.querySelector('.klaviyo-phoneinput button[role="combobox"]');
      const input = form?.querySelector('input[type="tel"]');
      if (!button || !input) return;
      if (button.querySelector('[aria-label="New Zealand"]')) { finish(); return; }
      if (input.value && !selecting) { finish(); return; }
      if (!selecting) {
        selecting = true;
        inertBefore = form.inert;
        form.inert = true;
        timer = setTimeout(() => {
          if (button.getAttribute('aria-expanded') === 'true') button.click();
          finish();
        }, 1500);
        button.click();
      }
      const option = form.querySelector('[role="option"] [aria-label="New Zealand"]')?.closest('[role="option"]');
      if (option) option.click();
    };
    const observer = new MutationObserver(initialise);
    root.addEventListener('pointerdown', onInteraction, true);
    root.addEventListener('keydown', onInteraction, true);
    observer.observe(root, {childList:true, subtree:true});
    initialise();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
(() => {
  const start = () => {
    if (window.Shopify?.theme?.id !== 154420740184 || location.pathname !== '/pages/hermosa-partners') return;
    const key = '__hermosaPartnersReturn';
    const saved = history.state?.[key];
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin !== location.origin || destination.pathname === location.pathname && destination.search === location.search) return;
      try {
        history.replaceState({...history.state, [key]: {url:location.href, y:scrollY, open:[...document.querySelectorAll('.hpv3__faq details')].map(el=>el.open)}}, '');
      } catch (_) {}
    });
    if (!saved || saved.url !== location.href || performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    const root = document.querySelector('.hpv3')?.closest('.shopify-section')?.nextElementSibling;
    if (!root) return;
    document.querySelectorAll('.hpv3__faq details').forEach((el,i)=>{el.open=!!saved.open?.[i]});
    let done = false;
    let pending = false;
    const stop = () => {
      done = true;
      observer.disconnect();
      clearTimeout(expiry);
      ['wheel','touchstart','pointerdown','keydown'].forEach(name=>window.removeEventListener(name,stop));
    };
    const restore = () => {
      if (done || pending || document.readyState !== 'complete' || !root.querySelector('[data-testid="klaviyo-form-SUtHdY"]')) return;
      pending = true;
      Promise.resolve(document.fonts?.ready).then(()=>requestAnimationFrame(()=>requestAnimationFrame(()=>{
        pending = false;
        if (done) return;
        window.scrollTo({top:saved.y,behavior:'instant'});
        stop();
      })));
    };
    const observer = new ResizeObserver(restore);
    const expiry = setTimeout(stop,15000);
    observer.observe(document.body);
    ['wheel','touchstart','pointerdown','keydown'].forEach(name=>window.addEventListener(name,stop,{once:true,passive:true}));
    window.addEventListener('load',restore,{once:true});
    restore();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();

  } catch(e) { console.error(e); }
})();
})();
